import React from 'react';
import { translate } from "react-translate";

import {
    Redirect,
    withRouter,
    Link,
} from 'react-router-dom'

import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    addToken,
    addId,
    addLanguage,
    addLogin,
    addReset,
    addRegister
} from '../../redux/actions/AppAction'

import { onSignIn } from '../../services/authService';

import {
    Grid,
    Modal,
    Button,
    Header,
    Input,
    Segment,
    Form,
    Divider,
    Checkbox,
    Image,
    Item,
    Icon,
} from 'semantic-ui-react'
import SocialComponent from './SocialComponent';
import './loginComponent.css'
import './socialComponent.css'
import './login_responsive.css'


import Exit from '../../assets/svg/Exit.svg';



function mapStateToProps(state) {
    return {
        app: state.app,
    };
}

const mapActionToProps = {
    addToken: addToken,
    addId: addId,
    addLanguage: addLanguage,
    addLogin: addLogin,
    addReset: addReset,
    addRegister: addRegister
}

class LoginComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToReferrer: false,
            email: null,
            password: null,
            error: null,
            error_input_email: true,
            error_input_password: true,
            warningError: null
        }
        this.handleChangeEmail = this.handleChangeEmail.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.addLogin = this.addLogin.bind(this);
        this.setRedirect = this.setRedirect.bind(this)
        this.addReset = this.addReset.bind(this)
        this.resetPassword = this.resetPassword.bind(this)
        this.addRegister = this.addRegister.bind(this)
    }

    handleChangeEmail(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                email: event.target.value,
                error_input_email: true
            })
        } else {
            this.setState({
                email: event.target.value,
                error_input_email: false
            })
        }
    }

    handleChangePassword(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                password: event.target.value,
                error_input_password: true

            })
        } else {
            this.setState({
                password: event.target.value,
                error_input_password: false
            })
        }
    }

    setToken(token) {
        this.props.addToken(token)
    }

    setId(id) {
        this.props.addId(id)
    }

    setLang(lang) {
        this.props.addLanguage(lang)
    }

    addReset() {
        this.props.addReset(true)
    }

    resetPassword() {
        this.addLogin()
        this.addReset()
    }

    setRedirect(bool) {
        this.setState({
            redirectToReferrer: bool
        })
    }

    handleSubmit(e) {
        e.preventDefault();

        const { t } = this.props

        if (!this.state.error_input_email && !this.state.error_input_password) {
            this.setState({
                warningError: null
            })

            onSignIn(this.state.email, this.state.password)
                .then(res => {
                    if (res) {
                        let token = localStorage.getItem('USER_TOKEN');
                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var tmp = JSON.parse(window.atob(base64));
                        let id = tmp['id'];
                        let lang = tmp['language'];
                        let email = tmp['username'];
                        this.setRedirect(true)
                        this.setToken(token)
                        this.setId(id)
                        this.setLang(lang)
                        this.addLogin();
                    }
                })
                .catch(err => {
                    this.setState({
                        error: err
                    })
                });
        } else {
            this.setState({
                warningError: t('everything')
            })
        }
    }

    addLogin() {
        this.props.addLogin(false);
    }

    addRegister() {
        this.props.addLogin(false);
        this.props.addRegister(true)
    }

    render() {
        var errorMessageLogin = {
            display:  'flex',
            justifyContent:  'center',
            alignItems:  'center',
            fontSize: '1.2em'
        }

        const { t } = this.props

        const { from } = this.props.location.state || { from: { pathname: "/" } };
        const { redirectToReferrer } = this.state;

        if (redirectToReferrer) {
            if (from === null || from.pathname === "/") {
                return <Redirect to="/homepage" />;
            }
            return <Redirect to={from} />;
        }

        return (
            // dans le cas du modal ??
            <div>
                <Modal id="modalLogin" observeChanges='true' size='mini' open={this.props.app.login} onClose={this.addLogin}>
                    <div ref={node => { this.node = node; }} >
                        <Modal.Content>
                            <Grid
                                textAlign='center'
                                verticalAlign='middle'
                                padded>
                                <Grid.Column id="modalLoginContent">
                                    <Image onClick={this.addLogin} src={Exit} floated='right' id="exit" />
                                    <Header as='h2' textAlign='center' id="modalLoginHeader">
                                        {t("Header1_title")}
                                    </Header>
                                    {/* SOCIAL COMPONENT <Demo /> */}
                                    <SocialComponent location={this.props.location} />
                                    <Divider id="divider" horizontal>{t("Divider1_title")}</Divider>
                                    <Form onSubmit={this.handleSubmit} id="formLogin">
                                        {
                                            this.state.error_input_email && this.state.warningError ? (
                                                <input onChange={this.handleChangeEmail}
                                                    placeholder={t("placeholder_email")}
                                                    type="email"
                                                    id="error" />

                                            ) : (
                                                    <input onChange={this.handleChangeEmail} placeholder={t("placeholder_email")} type="email" />
                                                )
                                        }
                                        {
                                            this.state.error_input_password && this.state.warningError ? (
                                                <input onChange={this.handleChangePassword}
                                                    placeholder={t("placeholder_password")}
                                                    type="password"
                                                    id="error" />

                                            ) : (
                                                    <input onChange={this.handleChangePassword} placeholder={t("placeholder_password")} type="password" />

                                                )
                                        }
                                        <Grid>
                                            <Grid.Row style={{ marginBottom: '20px' }} equal columns={2}>
                                                <Grid.Column>
                                                    <Form.Checkbox
                                                        inline
                                                        defaultChecked={true}
                                                        label='Se souvenir de moi'
                                                    />
                                                </Grid.Column>
                                                <Grid.Column textAlign='right'>
                                                    <a onClick={this.resetPassword} id="forgotPassword" >{t("Segment1_title")}</a><br />
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        {
                                            this.state.warningError ? (
                                                <Grid.Column style={{ paddingBottom: '15px' }}>
                                                    <Segment inverted color='red' tertiary style={errorMessageLogin}>
                                                        <Icon name={"remove circle"}  />{this.state.warningError}
                                                    </Segment>
                                                </Grid.Column>
                                            ) : (
                                                    <div></div>
                                                )
                                        }
                                        {
                                            this.state.error === null ? (
                                                <div></div>
                                            ) : (
                                                    <Grid.Column style={{ paddingBottom: '15px' }}>
                                                        <Segment inverted color='red' tertiary style={errorMessageLogin}>
                                                            {
                                                                this.state.error.code === 301 ? (
                                                                    <div>
                                                                        <Icon name={"remove circle"} />{t("error_login")}
                                                                    </div>

                                                                ) : (

                                                                        this.state.error.code === 302 ? (
                                                                            <div>
                                                                                <Icon name={"remove circle"}  />{t("error_login")}
                                                                            </div>

                                                                        ) : (

                                                                                this.state.error.code === 303 ? (
                                                                                    <div>
                                                                                        <Icon name={"remove circle"}  />{t("error_user_not_activated")}
                                                                                    </div>

                                                                                ) : (

                                                                                        <div></div>
                                                                                    )
                                                                            )
                                                                    )
                                                            }
                                                        </Segment>
                                                    </Grid.Column>
                                                )
                                        }
                                        <Button type='submit' fluid color='yellow' id="submitLoginBtn">{t("Button1_title")}</Button>
                                    </Form>
                                    <Header as='h5' id="account">{t("Header2_title")} <a onClick={this.addRegister} id="modalLoginLink"><u>{t("Header3_title")}</u></a></Header>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </div>
                </Modal>
            </div>
        );
    }
}


export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps),
    translate("LoginComponent")
)(LoginComponent);



// WEBPACK FOOTER //
// ./src/components/Login/LoginComponent.js